import styled from "styled-components";
import {
  fontSize,
  fontWeight,
  lineHeight,
  opacity,
  space,
  textAlign,
} from "styled-system";
import { SpanProps } from "./Span";

export const SpanBase = styled.span<SpanProps>`
  ${fontWeight}
  ${fontSize}
  ${space}
  ${textAlign}
  ${lineHeight}
  ${opacity}
`;
